import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Tree, Input } from 'antd'
import styled from 'styled-components'
const { Search } = Input
import { getCookie } from 'helper/cookie'
import { SearchOutlined } from '@ant-design/icons'
const HolidayContainer = styled.div``
let firsttimein = true
const TreeComponent = (props) => {
  const { treeCompany, setCompanyCallDelete, setdataSelect } = props

  const token = getCookie('access_token_admin')
  const [expandedKeys, setExpandedKeys] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [autoExpandParent, setAutoExpandParent] = useState(true)

  const [selectedKeys, setSelectedKeys] = useState()

  useEffect(() => {
    if (treeCompany.length > 0) {
      // firsttimein == true && treeCompany.length > 0
      setExpandedKeys([treeCompany[0].key])
      setSelectedKeys([treeCompany[0].key])
    } else {
      setExpandedKeys(expandedKeys)
      setSelectedKeys(selectedKeys)
    }
  }, [treeCompany])
  const dataList = []
  const generateList = (data) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const { key } = node
      dataList.push({ key, title: key })
      if (node.children) {
        generateList(node.children)
      }
    }
  }
  generateList(treeCompany)

  const getParentKey = (key, tree) => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children)
        }
      }
    }
    return parentKey
  }

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const onChange = (e) => {
    const { value } = e.target
    const expandedKeys = dataList.map((item) => {
      if (item?.title?.toLowerCase()?.includes(value?.toLowerCase())) {
        return getParentKey(item.key, treeCompany)
      }
      return null
    })

    setExpandedKeys(expandedKeys)
    setSearchValue(value)
    setAutoExpandParent(true)
  }

  const [checkSearch, setCheckSearch] = useState([])

  const [displayTree, setDisplayTree] = useState(true)

  let arr = []

  const checkDataSearch = async (data) => {
    await data.map((item) => {
      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())
      arr.push(index)

      if (item.children) {
        return {
          key: item.key,
          children: checkDataSearch(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }
    })
    setCheckSearch(arr)
  }

  useEffect(() => {
    let havedata = false
    checkSearch.map((item) => {
      if (item == true) {
        havedata = true
      }
    })
    if (checkSearch.length == 0) {
      setDisplayTree(true)
    } else {
      setDisplayTree(havedata)
    }
  }, [checkSearch])

  useEffect(() => {
    arr = []
    checkDataSearch(treeCompany)
  }, [searchValue])

  const loop = (data) =>
    data.map((item) => {
      const index = item.title.toLowerCase().includes(searchValue.toLowerCase())
      let code = item.title.split(' ')

      let titleCODE = code[0]
      let nameCODE = []
      code.map((item, index) => {
        if (index != 0) {
          nameCODE.push(item)
        }
      })
      let realtitle = nameCODE.join(' ')

      const title =
        index == true && searchValue != '' ? (
          item.level == 0 ? (
            <span
              className="event-search-tree-container"
              style={{
                display: 'flex',
                alignItems: 'center',

                marginTop: 4.5,
              }}
            >
              <h5 className="code-tree-style">{titleCODE}</h5>
              <h5
                className="title-cut"
                style={{
                  marginLeft: 8,
                  background: 'rgba(18, 126, 195, 0.16)',
                  padding: '0px 4px 0px 4px',
                  borderRadius: 16,
                }}
              >
                {realtitle}
              </h5>
            </span>
          ) : (
            <p
              className="title-cut"
              style={{
                background: 'rgba(18, 126, 195, 0.16)',
                padding: '0px 4px 0px 4px',
                borderRadius: 16,
                marginTop: 6,
              }}
            >
              {item.title}
            </p>
          )
        ) : item.level == 0 ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 4.5,
            }}
          >
            <h5 className="code-tree-style">{titleCODE}</h5>
            <h5 className="title-cut" style={{ marginLeft: 8 }}>
              {realtitle}
            </h5>
          </span>
        ) : (
          <p
            className="title-cut"
            style={{
              marginTop: 6,
            }}
          >
            {item.title}
          </p>
        )

      if (item.children) {
        return {
          title,
          key: item.key,
          children: loop(item.children),
          level: item.level,
          level_id: item.level_id,
          id: item.id,
          item: item,
        }
      }

      return {
        title,
        key: item.key,
        level: item.level,
        level_id: item.level_id,
        id: item.id,
        item: item,
      }
    })

  const onClick = (e, value) => {
    setdataSelect(value.item)
    setSelectedKeys([value.item.key])
    setCompanyCallDelete(value.item.company_id)

    let checkrepeat = false
    if (expandedKeys) {
      expandedKeys.map((item) => {
        if (item == value.item.key) {
          checkrepeat = true
        }
      })
    }

    if (checkrepeat == false) {
      setExpandedKeys((prev) => [...prev, value.item.key])
    }

    firsttimein = false
  }

  return (
    <HolidayContainer>
      <div>
        {/* <div style={{ marginTop: 32, marginBottom: 32, marginLeft: 16, marginRight: 16 }}>
          <Input
            placeholder='Search'
            allowClear
            suffix={<SearchOutlined style={{ fontSize: 20 }} />}
            onChange={onChange}
            size='large'
          />
        </div> */}

        <Tree
          style={{ marginLeft: 16, marginRight: 16, display: displayTree ? _ : 'none' }}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          treeData={loop(treeCompany)}
          onClick={(e, value) => onClick(e, value)}
          selectedKeys={selectedKeys}
        />
      </div>
    </HolidayContainer>
  )
}
export default TreeComponent
